module.exports = __webpack_public_path__ + "static/media/box-img-1.63635a5d.jpg";